import { Grid, Typography, useTheme } from '@material-ui/core'
import React from 'react'
import { getStyles } from 'isotope-client'
import withStyles from '@material-ui/core/styles/withStyles'
import { FormattedMessage, useIntl } from 'react-intl'
import { colors } from '../../../utils/constants'
import QuestionIcon from '../../../components/icon/QuestionIcon'
import Tooltip from '@material-ui/core/Tooltip'

const styles = (theme) => getStyles({
	container: {
		backgroundColor: theme.palette.primary.light,
		height: 100,
		width: 275
	},
	titleBloc: {
		paddingLeft: 15,
		paddingRight: 15
	},
	title: {
		alignContent: 'center',
		paddingLeft: 10
	},
	help: {
		cursor: 'pointer'
	},
	bigIcon: {
		fill: theme.palette.primary.main,
		width: 25,
		height: 25
	},
	value: {
		fontSize: 35,
		fontWeight: 'bold',
		paddingLeft: 48,
		marginTop: -12
	},
	secondaryValue: {
		fontSize: 15,
		paddingRight: 30
	},
	secondaryMessage: {
		color: colors.primary,
		fontSize: 12,
		paddingLeft: '18%',
		marginTop: -3
	}
})

/**
 * Méthode qui renvoie la couleur que le texte du bloc doit prendre
 * @param colorParam la couleur est passée directement dans les param du composant StatBloc
 * @param getPourcentageCouleur la méthode pour determinée la couleur est passée dans les param du composant StatBloc
 * @param value valeur du bloc
 * @param isPourcentage la valeur du bloc est un pourcentage
 * @param total
 * @param reversePourcentage si on inverse le pourcentage (valable pour l'onglet ecart par culture)
 * @param theme theme pour récupérer la palette primary
 * @returns {*|string}
 */
const getColor = (colorParam, getPourcentageCouleur, value, isPourcentage, total, reversePourcentage, theme) => {
	if (colorParam) {
		return colorParam
	} else if (getPourcentageCouleur) {
		return getPourcentageCouleur(value, (isPourcentage ? undefined : total), reversePourcentage)
	} else {
		return theme.palette.primary.main
	}
}

/**
 * Bloc d'affichage de statistiques
 * @param Icon icon du bloc
 * @param values object - 0: la valeur principale du bloc ; 1: l'éventuelle valeur secondaire du bloc
 * @param total
 * @param baseMessage le noeud du message (title, subtitle) selon les messages à afficher
 * @param unite unité de la valeur ("h" par exemple)
 * @param isPourcentage est ce que le bloc ne contient qu'un pourcentage
 * @param reversePourcentage si on inverse le pourcentage (valable pour l'onglet ecart par culture)
 * @param withHelp pour afficher une tooltip d'aide sur chaque bloc
 * @param withSecondaryMessage pour indiquer que le bloc contient deux textes
 * @param getPourcentageCouleur fonction qui determine la couleur du pourcentage si colorParam n'est pas défini
 * @param colorParam la couleur du texte du message
 * @param classes les classes css
 * @returns {Element}
 * @constructor
 */
const StatBloc = ({
	Icon,
	values,
	total,
	baseMessage,
	unite,
	isPourcentage,
	reversePourcentage,
	withHelp,
	helpValues = {},
	withSecondaryMessage,
	getPourcentageCouleur,
	colorParam,
	classes,
}) => {
	const intl = useIntl()
	const theme = useTheme()
	const color = getColor(colorParam, getPourcentageCouleur, values[0], isPourcentage, total, reversePourcentage, theme)

	return (
		<Grid container item alignContent="center" justify="center" direction="column" className={classes.container}>
			<Grid container item justify="space-between" alignItems="center" className={classes.titleBloc}>
				<Grid item xs={withHelp ? 11 : 12} container alignContent="flex-start" justify="flex-start">
					<Icon className={classes.bigIcon} />
					<Typography className={classes.title}><FormattedMessage id={`${baseMessage}.title`} /></Typography>
				</Grid>
				{withHelp && <Grid item xs={1} className={classes.help}>
					<Tooltip title={intl.formatMessage({ id: `${baseMessage}.help` }, helpValues)}>
						<Grid item>
							<QuestionIcon height="18px" width="18px" />
						</Grid>
					</Tooltip>
				</Grid>}
			</Grid>

			<Grid container item justify="space-between" alignItems="center">
				<Typography style={{ color }} className={classes.value}>
					{`${values[0] ?? 0}${isPourcentage ? ' %' : (unite ?? '')}`}
				</Typography>
				{values[1] && <Typography style={{ color }} className={classes.secondaryValue}>
					{`${values[1]} %`}
				</Typography>}
			</Grid>
			{withSecondaryMessage && <Typography className={classes.secondaryMessage}>
				<FormattedMessage className={classes.secondaryMessage} id={`${baseMessage}.subtitle`} />
			</Typography>}
		</Grid>
	)
}

export default withStyles(styles)(StatBloc)